import { Routes } from '@angular/router';
import { AI_CHAT_SESSION_CONFIG } from './base/ai-chat-session-config';

/**
 * AI 상담 세션 Feature Routes
 *
 * - List Page: /requests/ai-chat-session
 */
export const aiChatSessionRoutes: Routes = [
  {
    path: AI_CHAT_SESSION_CONFIG.routePath,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/ai-chat-session-list-page/ai-chat-session-list-page.component'
          ).then((m) => m.AiChatSessionListPageComponent),
      },
    ],
  },
];
